import React, { useContext } from "react";
import styles from "./RequiredLabel.module.scss";
import { LanguageContext } from "../../../context/LanguageProvider";

const RequiredLabel = ({ text, required = false, dir = "ltr" }) => {
  const { selectedLanguage } = useContext(LanguageContext);

  return (
    <div dir={selectedLanguage?.dir} className={styles.requiredLabel}>
      {text}
      {required && <span style={{ color: "red" }}>*</span>}
    </div>
  );
};

export default RequiredLabel;
